<template>
  <div class="detail">
    <div class="des">
      <div style="display: flex;align-items: center;gap: 10px;margin-bottom: 10px">
        <div class="title" style="margin: 0">{{resData.restypeName}}</div>
        <el-tag @click="backToKind" size="small" style="cursor: pointer;">返回</el-tag>
      </div>
      <el-descriptions :colon=false>
        <el-descriptions-item label="代码">
          <span class="colon">:</span>
          {{resData.restypeNumber}}
        </el-descriptions-item>
        <el-descriptions-item label="资源类型">
          <span class="colon">:</span>
          <DictTag :options="dropDown.kind" :value="resData.kind"/>
        </el-descriptions-item>
        <el-descriptions-item label="资源大类交易类型">
          <span class="colon">:</span>
          <DictTag :options="dropDown.kindDealType" :value="resData.kindDealType"/>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="list">
      <div class="title">资源详情</div>
      <el-tabs v-model="activeName" type="card" class="tabs1">
        <el-tab-pane :label="resData.restypeName + '-列表'" name="1">
          <div class="contain">
            <div class="left" ref="querytree">
              <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item :title="item.label" :name="index + 1" v-for="(item, index) in cbussDimeTree" :key="index">
                  <el-tree
                    :data="item.children"
                    :props="defaultProps"
                    @node-click="handleNodeClick($event, index)"
                    default-expand-all
                    :ref="'tree' + (index + 1)"
                    :expand-on-click-node="false"
                    highlight-current
                    node-key="value">
                  </el-tree>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div class="right">
              <el-form :inline="true" :model="resFormInline" class="demo-form-inline" size="small" @submit.native.prevent label-width="90px">
                <el-form-item>
                  <strong slot="label">资源名称</strong>
                  <el-input v-model="resFormInline.resourceName" placeholder="请输入资源名称" clearable @keyup.enter.native="inquire" @clear="inquire"  style="width:240px" ></el-input>
                </el-form-item>
                <el-form-item>
                  <strong slot="label">规格型号</strong>
                  <el-input v-model="resFormInline.ggxh" placeholder="请输入规格型号" clearable @keyup.enter.native="inquire" @clear="inquire"  style="width:240px" ></el-input>
                </el-form-item>
                <el-form-item>
                  <strong slot="label">计量单位</strong>
                  <el-input v-model="resFormInline.jldw" placeholder="请输入计量单位" clearable @keyup.enter.native="inquire" @clear="inquire"  style="width:240px" ></el-input>
                </el-form-item>
                <el-form-item v-if="resData.isBom == '0'">
                  <strong slot="label">是否含bom</strong>
                  <el-select v-model="resFormInline.bom" placeholder="是否含bom" clearable @keyup.enter.native="inquire" @change="inquire"  style="width:240px" >
                    <el-option value="Y" label="是"></el-option>
                    <el-option value="N" label="否"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <strong slot="label">是否含批次</strong>
                  <el-select v-model="resFormInline.thing" placeholder="是否含批次" clearable @keyup.enter.native="inquire" @change="inquire"  style="width:240px" >
                    <el-option value="Y" label="是"></el-option>
                    <el-option value="N" label="否"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <strong slot="label">位置</strong>
                  <treeselect style="width:240px" v-model="resFormInline.cbowhId" :options="cbOwhTree" :normalizer="normalizer" placeholder="请选择位置" />
                </el-form-item>
                <el-form-item v-for="(item, index) in cbussDimeList" :key="index">
                  <strong slot="label">{{item.dimeName}}</strong>
                  <!-- 输入框 -->
                    <el-input
                      v-if="item.editType == '1' || item.editType == '2'"
                      v-model="item.showValue"
                      :placeholder="'请输入' + item.dimeName"
                      clearable
                      @keyup.enter.native="inquire"
                      @clear="inquire"
                      style="width:240px"
                    ></el-input>
                    <!-- 日期范围 -->
                    <el-date-picker
                      v-if="item.editType == '5' || item.editType == '9' || item.editType == '22'"
                      v-model="item.showValue"
                      type="daterange"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      class="my-el-date-picker"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width:240px"
                      @change="inquire">
                    </el-date-picker>
                    <!-- 资源 -->
                    <el-select
                      v-if="item.editType == '12'"
                      v-model="item.showValue"
                      clearable
                      filterable
                      :placeholder="'请选择' + item.dimeName"
                      @change="inquire"
                      style="width:240px"
                    >
                      <el-option
                        v-for="(drop, id) in item.options"
                        :key="id"
                        :label="drop.resourceName"
                        :value="drop.ofrResourceId + ''"
                      ></el-option>
                    </el-select>
                    <!-- 内容 -->
                    <el-select
                      v-if="item.editType == '13'"
                      style="width: 240px"
                      v-model="item.showValue"
                      clearable
                      filterable
                      :placeholder="'请选择' + item.dimeName"
                      @change="inquire"
                    >
                      <el-option-group
                        v-for="(group, id1) in item.options"
                        :key="id1"
                        :label="group.resourceName">
                        <el-option
                          v-for="(drop, id) in group.ofrThingList"
                          :key="id"
                          :label="drop.name"
                          :value="drop.ofrThingId + ''">
                        </el-option>
                      </el-option-group>
                    </el-select>
                    <!-- 项目 -->
                    <el-select
                      v-if="item.editType == '14'"
                      style="width: 240px"
                      v-model="item.showValue"
                      clearable
                      filterable
                      :placeholder="'请选择' + item.dimeName"
                      @change="inquire"
                    >
                      <el-option-group
                        v-for="(group, id1) in item.options"
                        :key="id1"
                        :label="group.showName">
                        <el-option
                          v-for="(drop, id) in group.ofoFlowItemList"
                          :key="id"
                          :label="drop.name"
                          :value="drop.ofoItemId + ''">
                        </el-option>
                      </el-option-group>
                    </el-select>
                    <InputNumberRange precision="2" v-if="item.editType == '4' || item.editType == '10'" v-model="item.showValue" style="width:240px" ref="inputNumber"/>
                    <InputNumberRange v-if="item.editType == '11'" v-model="item.showValue" style="width:240px" percent ref="inputNumber"/>
                    <el-cascader
                      v-if="item.editType == '20'"
                      style="width: 97%"
                      :options="JSON.parse(item.options)"
                      v-model="item.showValue"
                      :props="{ checkStrictly: true,value: 'optionValue',label:'optionLabel',emitPath: false }"
                      :placeholder="'请选择' + item.dimeName"
                      @change="inquire"
                      clearable></el-cascader>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="inquire" style="background:#0C75E5">查询</el-button>
                  <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
                  <el-button plain type="warning" icon="el-icon-download" @click="handleDown">导出</el-button>
                </el-form-item>
              </el-form>
              <el-button type="primary" plain size="small" icon="el-icon-plus" @click="addResource" v-if="judgeButton('add')">新增</el-button>
              <el-button type="primary" plain size="small" icon="el-icon-copy" @click="copyResource" :disabled="!isEditResource" v-if="judgeButton('add')">复用</el-button>
              <el-button type="success" plain size="small" icon="el-icon-edit" @click="editResource" :disabled="!isEditResource" v-if="judgeButton('edit')">编辑</el-button>
              <el-button type="danger" plain size="small" icon="el-icon-delete" @click="deleteResource" :disabled="!isDelResource" v-if="judgeButton('delete')">删除</el-button>
              <el-button type="primary" plain size="small" icon="el-icon-plus" @click="handleBatch" :disabled="!isDelResource" v-if="resData.isPrivate == '0'">批量分配</el-button>
              <el-button type="primary" plain size="small" icon="el-icon-share" @click="handleShare" :disabled="!isEditResource">分享</el-button>
              <el-button type="primary" size="small" icon="el-icon-info" v-if="resData.isBom == '0' && judgeButton('bom')" @click="handleDime">BOM配置</el-button>
              <el-button type="primary" size="small" icon="el-icon-info" v-if="resData.isBom == '0' && judgeButton('bom')" @click="handleBatchImport">BOM导入</el-button>
              <el-table
                :data="resourceList"
                tooltip-effect="dark"
                style="width: 100%;margin-top:16px"
                @selection-change="handleSelectionChange"
                :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
                v-loading="loadingResource"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="remarks" label="描述" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="resourceName" label="资源名称" width="150">
                  <template slot-scope="scope">
                    <a @click="handleContent(scope.row)" class="link">{{scope.row.resourceName}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="resourceNumber" label="编号" show-overflow-tooltip></el-table-column>
                <el-table-column property="ggxh" label="规格型号" v-if="resData.kind == '2' || resData.kind == '3'" width="200"></el-table-column>
                <el-table-column property="jldw" label="单位" v-if="resData.kind == '2' || resData.kind == '3'" width="80"></el-table-column>
                <el-table-column prop="belongName" label="归属人" v-if="resData.isPrivate == '0'" width="100"></el-table-column>
                <el-table-column prop="rprice" label="销售价" v-if="resData.isShowPrice == '0'" width="100"></el-table-column>
                <el-table-column prop="cprice" label="成本价" v-if="resData.isShowPrice == '0'" width="100"></el-table-column>
<!--                <el-table-column prop="createTime" label="创建时间" width="110">
                  <template slot-scope="scope">
                    {{parseTime(scope.row.createTime, '{y}-{m}-{d}')}}
                  </template>
                </el-table-column>-->
                <el-table-column v-for="(item, index) in resDimeList" :key="index" :label="item.dimeName" width="150" v-if="item.columnshow == '0'">
                  <template slot-scope="scope">
                    <div v-for="(val, id) in scope.row.obussDimeList" :key="id" v-if="item.cbdId == val.cbdId">{{val.dimeText}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="remarks" label="是否显示" width="80" align="center">
                  <template slot-scope="scope">
                    <el-switch
                      v-model="scope.row.isShow"
                      active-value="0"
                      inactive-value="1"
                      @change="changeSwitch($event, scope.row)">
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column prop="ojdt" label="是否内部组织" v-if="resData.kind === '6'">
                  <template slot-scope="scope">
                    <el-switch
                      v-model="scope.row.ojdt"
                      active-value="0"
                      inactive-value="1"
                      @change="changeSwitch2($event, scope.row)">
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="120">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      icon="el-icon-edit"
                      @click.native.stop="editResource(scope.row)"
                      type="text"
                      v-if="judgeButton('edit')"
                    >编辑
                    </el-button>
                    <el-button
                      size="mini"
                      icon="el-icon-delete"
                      @click.native.stop="deleteResource(scope.row)"
                      type="text"
                      v-if="judgeButton('delete')"
                    >删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNumResource"
                :page-sizes="[10, 20, 50, 100, 200]"
                :page-size="pageSizeResource"
                layout="->, total, sizes, prev, pager, next, jumper"
                :total="totalReource">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="resData.restypeName + '-资源维度'" name="2">
          <Resource v-if="activeName === '2'" :cbRestypeId="resData.cbRestypeId" :cbRestype="resData"/>
        </el-tab-pane>
        <el-tab-pane :label="resData.restypeName + '-内容维度'" name="3">
          <Content v-if="activeName === '3'" :cbRestypeId="resData.cbRestypeId"/>
        </el-tab-pane>
        <el-tab-pane :label="resData.restypeName + '-别名'" name="4">
          <Alias v-if="activeName === '4'" :resData="resData"/>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 新增修改资源对话框 -->
    <el-dialog v-dialog-drag
      :title="resourceTitle"
      :visible.sync="resourceDialog"
      :append-to-body="true"
    >
      <el-form
        :model="ruleFormRes"
        :rules="rules"
        ref="ruleFormRes"
        class="demo-ruleFormRes"
        style="max-height: 50vh; overflow-y: auto;overflow-x: hidden"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称" prop="resourceName">
              <el-input
                v-model="ruleFormRes.resourceName"
                :placeholder="'请输入' + resData.restypeName + '名称'"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isPrivate == '0'">
            <el-form-item label="归属人" prop="userId">
              <el-select v-model="ruleFormRes.userId" placeholder="请选择归属人" style="width:97%" filterable>
                <el-option-group
                  v-for="group in userList"
                  :key="group.ofrResourceId"
                  :label="group.resourceName">
                  <el-option
                    v-for="item in group.ofrThingList"
                    :key="item.ofrThingId"
                    :label="item.name"
                    :value="item.ofrThingId">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isShowPrice == '0'">
            <el-form-item label="销售价" prop="rprice">
              <el-input
                v-model="ruleFormRes.rprice"
                placeholder="请输入销售价"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isShowPrice == '0'">
            <el-form-item label="成本价" prop="cprice">
              <el-input
                v-model="ruleFormRes.cprice"
                placeholder="请输入成本价"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.isShowPrice == '0'">
            <el-form-item label="税率" prop="rslv">

              <el-select v-model="ruleFormRes.rslv" placeholder="请选择税率" style="width:97%" clearable>
                <el-option
                  v-for="item in dropDown.invoiceVat"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="规格型号" prop="ggxh">
              <el-input
                v-model="ruleFormRes.ggxh"
                placeholder="请输入规格型号"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="单位" prop="jldw">
              <el-input
                v-model="ruleFormRes.jldw"
                placeholder="请输入单位"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="双计系数" prop="sjxs">
              <el-input
                type="number"
                v-model="ruleFormRes.sjxs"
                placeholder="请输入双计系数"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '2' || resData.kind == '3'">
            <el-form-item label="双计单位" prop="sjdw">
              <el-input
                v-model="ruleFormRes.sjdw"
                placeholder="请输入双计单位"
                style="width: 97%"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 伙伴-额度管理 -->
          <el-col :span="12" v-if="resData.kind == '7' && resData.edgl == '0'">
            <el-form-item label="额度" prop="edje">
              <el-input
                v-model="ruleFormRes.edje"
                placeholder="请输入额度"
                style="width: 97%"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '7' && resData.edgl == '0' && judgeButton('lsed')">
            <el-form-item label="临时额度" prop="lsed">
              <el-input
                v-model="ruleFormRes.lsed"
                placeholder="请输入临时额度"
                style="width: 97%"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
<!--          <el-col :span="12" v-if="resData.kind == '7' && resData.edgl == '0' && judgeButton('lsed')">
            <el-form-item label="临时额度起始日期" prop="lsedBegin">
              <el-date-picker
                v-model="ruleFormRes.lsedBegin"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resData.kind == '7' && resData.edgl == '0' && judgeButton('lsed')">
            <el-form-item label="临时额度截至日期" prop="lsedEnd">
              <el-date-picker
                v-model="ruleFormRes.lsedEnd"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>-->
          <!-- <el-col :span="12" v-if="resData.kind == '7' && resData.edgl == '0'">
            <el-form-item label="额度活动" prop="edid">
              <treeselect v-model="ruleFormRes.edid" :options="cflowItemTree" :normalizer="normalizer1" placeholder="请选择额度活动" :disable-branch-nodes="true" :flat="true" :appendToBody="true" z-index="9000" />
            </el-form-item>
          </el-col> -->
          <!-- 伙伴-账期管理 -->
          <el-col :span="12" v-if="resData.kind == '7' && resData.zqgl == '0'">
            <el-form-item label="账期天数" prop="zqts">
              <el-input
                v-model="ruleFormRes.zqts"
                placeholder="请输入账期天数"
                style="width: 97%"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12" v-if="resData.kind == '7' && resData.zqgl == '0'">
            <el-form-item label="账期活动" prop="zqid">
              <treeselect v-model="ruleFormRes.zqid" :options="cflowItemTree" :normalizer="normalizer1" placeholder="请选择账期活动" :disable-branch-nodes="true" :flat="true" :appendToBody="true" z-index="9000"/>
            </el-form-item>
          </el-col> -->
        </el-row>
        <Form :formList="formList" :gutter="20" :ruleForm="ruleFormRes"/>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resourceDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleFormRes')" :loading="isLoadingRes">确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 修改归属人对话框 -->
    <el-dialog v-dialog-drag
      title="修改归属人"
      :visible.sync="belongDialog"
      :append-to-body="true"
      width="500px"
    >
      <el-form
        :model="ruleFormRes"
        ref="ruleBelongForm"
        style="max-height: 50vh; overflow-y: auto;overflow-x: hidden"
        label-position="right"
      >
        <el-form-item label="归属人" prop="userId">
          <el-select v-model="ruleFormRes.userId" placeholder="请选择归属人" style="width:97%" filterable>
            <el-option-group
              v-for="group in userList"
              :key="group.ofrResourceId"
              :label="group.resourceName">
              <el-option
                v-for="item in group.ofrThingList"
                :key="item.ofrThingId"
                :label="item.name"
                :value="item.ofrThingId">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="belongDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitBelong" :loading="isLoadingRes">确 定</el-button>
      </div>
    </el-dialog>
    <el-drawer
      :title="contentData.resourceName"
      :visible.sync="drawer"
      size="80%">
      <div style="padding:16px">
        <!-- <el-descriptions>
          <el-descriptions-item label="代码">{{contentData.resourceNumber}}</el-descriptions-item>
          <el-descriptions-item label="类型">{{resData.restypeName}}
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            <DictTag :options="dropDown.documentstatus" :value="contentData.documentstatus"/>
          </el-descriptions-item>
        </el-descriptions> -->
        <!-- 内部 -->
        <template v-if="resData.kindDealType == '0' || resData.kindDealType == null">
          <el-tabs v-model="thingName" type="border-card" class="tabs1">
            <el-tab-pane label="BOM" name="7" v-if="resData.isBom == '0'">
              <Bom :contentData="contentData" />
            </el-tab-pane>
            <el-tab-pane label="内容" name="1">
              <InContent v-if="thingName == '1'" :resourceName="contentData.resourceName" :ofrResourceId="contentData.ofrResourceId" ref="inContent" :resData="resData"/>
            </el-tab-pane>
            <el-tab-pane v-if="judgeHistoryButton('his')" label="历史记录" name="9">
              <History :kind="resData.kind" :ofr-resource-id="ofrResourceId"/>
            </el-tab-pane>

          </el-tabs>
        </template>
        <!-- 外部 -->
        <template v-if="resData.kindDealType == '1'">
          <el-tabs v-model="thingName" type="border-card" class="tabs1">
            <el-tab-pane label="BOM" name="8" v-if="resData.isBom == '0'">
              <Bom :contentData="contentData" />
            </el-tab-pane>
            <el-tab-pane label="联系信息" name="2">
              <OutContent v-if="thingName == '2'" :thingDimeType="'1'" :resourceName="contentData.resourceName" :resId="contentData.ofrResourceId" :cbRestypeId="resData.cbRestypeId" :resData="resData"/>
            </el-tab-pane>
            <el-tab-pane label="发票信息" name="3">
              <OutContent v-if="thingName == '3'" :thingDimeType="'2'" :resourceName="contentData.resourceName" :resId="contentData.ofrResourceId" :cbRestypeId="resData.cbRestypeId" :resData="resData"/>
            </el-tab-pane>
            <el-tab-pane label="账户信息" name="4">
              <OutContent v-if="thingName == '4'" :thingDimeType="'3'" :resourceName="contentData.resourceName" :resId="contentData.ofrResourceId" :cbRestypeId="resData.cbRestypeId" :resData="resData"/>
            </el-tab-pane>
            <el-tab-pane label="物流信息" name="5">
              <OutContent v-if="thingName == '5'" :thingDimeType="'4'" :resourceName="contentData.resourceName" :resId="contentData.ofrResourceId" :cbRestypeId="resData.cbRestypeId" :resData="resData"/>
            </el-tab-pane>
            <el-tab-pane label="其他信息" name="6">
              <OutContent v-if="thingName == '6'" :thingDimeType="'9'" :resourceName="contentData.resourceName" :resId="contentData.ofrResourceId" :cbRestypeId="resData.cbRestypeId" :resData="resData"/>
            </el-tab-pane>
            <el-tab-pane v-if="judgeHistoryButton('his')" label="历史记录" name="9">
              <History :kind="resData.kind" :ofr-resource-id="ofrResourceId"/>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
    </el-drawer>
    <!-- 新增维度配置对话框 -->
    <el-dialog v-dialog-drag
      title="BOM动态配置"
      :visible.sync="dimeDialog"
      :append-to-body="true"
      width="80%"
      top="59px"
    >
      <h3>
        固定维度
        <el-button type="text" icon="el-icon-circle-plus-outline" @click="addDime('fixed')"></el-button>
      </h3>
      <uniseriate-form :formList="fixedDimes" :form="false" dimeName isDelete />
      <h3>
        配置维度
        <el-button type="text" icon="el-icon-circle-plus-outline" @click="addDime('config')"></el-button>
      </h3>
      <el-table :data="configDimes" border style="width:100%" :show-header="false">
        <el-table-column prop="dimeName">
          <template slot-scope="scope">
            {{scope.row.dimeName}}
            <el-button type="text" icon="el-icon-circle-plus-outline" @click="addColumn(scope.$index)"></el-button>
          </template>
        </el-table-column>
        <el-table-column prop="dimeName">
          <!-- <template #header>
            <el-button type="text" icon="el-icon-delete" @click="deleteColumn(id)"></el-button>
          </template> -->

          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.obussDimes" :key="index">
              <uniseriate-form :formList="[item]" :form="false" isDelete />
            </div>

          </template>
        </el-table-column>
        <el-table-column prop="dimeName" width="50">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-delete" @click="handleDelete(scope.$index)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <h3>
        BOM
        <el-button type="text" icon="el-icon-circle-plus-outline" @click="handleAddBom()"></el-button>
        <el-button type="text" icon="el-icon-document-copy" @click="handleCopy()"></el-button>
      </h3>
      <!-- <el-button type="primary" plain size="small" icon="el-icon-plus" @click="handleAddBom({bomId: 0})">新增</el-button> -->
      <!-- <el-button size="small" type="primary" @click="handleAddBom">选择资源</el-button> -->
      <el-table
        :data="bomData"
        tooltip-effect="dark"
        style="width: 100%;"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
        row-key="bomId"
        default-expand-all
        :tree-props="{children: 'children'}"
        :summary-method="getSummaries"
        show-summary>
        <el-table-column
          type="selection"
          width="75">
        </el-table-column>
        <el-table-column
          type="index"
          width="55"
          label="行号">
        </el-table-column>
        <el-table-column
          prop="ofrResourceName"
          label="资源名称">
          <!-- <template slot-scope="scope">
            <a @click="handleView(scope.row)" class="link">{{scope.row.name}}</a>
          </template> -->
        </el-table-column>
        <el-table-column
          label="数量"
          prop="quantity"
          width="120"
          align="right"
          header-align="center">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.quantity"
              size="mini"
              class="right-input"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="金额"
          prop="price"
          width="120"
          align="right"
          header-align="center">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.price"
              size="mini"
              class="right-input"
            ></el-input>
          </template>
          <!-- <template slot-scope="scope">
            {{scope.row.price | comdify('no')}}
          </template> -->
        </el-table-column>
        <el-table-column
          label="损耗率"
          prop="lossRate"
          width="125">
          <template slot-scope="scope">
            <!-- {{scope.row.lossRate ? scope.row.lossRate + '%' : ''}} -->
            <el-input
              v-model="scope.row.lossRate"
              size="mini"
              class="right-input"
            >
              <template slot="append">%</template>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="描述"
          prop="remark"
          width="140"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- {{scope.row.lossRate ? scope.row.lossRate + '%' : ''}} -->
            <el-input
              v-model="scope.row.remark"
              size="mini"
            >
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="jc"
          label="简称"
          min-width="200">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.jc"
              size="mini"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.sort"
              size="mini"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="120">
          <template slot-scope="scope">
            <el-button
              size="mini" icon="el-icon-plus" type="text"
              @click="handleAddBom(scope.row)">新增</el-button>
            <!-- <el-button
              size="mini" icon="el-icon-edit" type="text"
              @click="handleEdit(scope.row)">编辑</el-button> -->
            <el-button
              size="mini" icon="el-icon-delete" type="text"
              @click="handleDeleteBom(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dimeDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitDime" :loading="isLoadingRes">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增维度对话框 -->
    <el-dialog v-dialog-drag
      title="维度配置"
      :visible.sync="dimeListDialog"
      :append-to-body="true"
      width="500px"
    >
      <el-select v-model="selectDimes" multiple placeholder="请选择维度">
        <el-option
          v-for="item in resDimeList"
          :key="item.cbdId"
          :label="item.dimeName"
          :value="item.cbdId">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dimeListDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAddDime" :loading="isLoadingRes">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-dialog-drag
      title="选择资源"
      :visible.sync="dialogResVisible"
      :append-to-body="true"
      width="80%"
      top="59px"
      class="res-dialog"
    >
      <!-- <el-select v-model="ofrResourceIds" placeholder="请选择资源" filterable style="width: 100%" multiple size="small">
        <el-option-group
          v-for="(group, index) in resTreeList"
          :key="index"
          :label="group.name">
          <el-option
            v-for="item in group.resourceList"
            :key="item.ofrResourceId"
            :label="item.remarks"
            :value="item.ofrResourceId">
          </el-option>
        </el-option-group>
      </el-select> -->
      <el-table
        ref="restypeTable"
        :data="resList"
        tooltip-effect="dark"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
        style="width: 100%"
        @selection-change="handleResSelectionChange"
        @row-click="clickRowRes"
        size="small"
        :height="tableHeight"
        row-key="ofrResourceId"
        >

        <el-table-column
          label="资源种类"
          prop="restypeName"
          width="150">
        </el-table-column>
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55">
        </el-table-column>
        <el-table-column
          label="描述"
          prop="remarks">
        </el-table-column>
        <el-table-column
          label="名称"
          prop="resourceName">
        </el-table-column>
        <el-table-column
          label="规格型号"
          prop="ggxh"
          width="100">
        </el-table-column>
        <el-table-column
          label="单位"
          prop="jldw"
          width="100">
        </el-table-column>
        <el-table-column
          align="right" width="200">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="输入名称搜索"
              clearable
              @input="searchChange"
              @keyup.enter.native="searchChange">
              <!-- <el-button slot="append" icon="el-icon-search" @click="searchChange"></el-button> -->
            </el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="pageinfo.pageNum"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pageinfo.pageSize"
        layout="->, total, sizes, prev, pager, next, jumper"
        :total="pageinfo.total"
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        style="margin-bottom: 3px"></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogResVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRes">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-dialog-drag
      title="复制BOM"
      :visible.sync="dialogCopyVisible"
      :append-to-body="true"
      width="30%"
    >
      <el-form
        :model="formCopy"
        :rules="copyRules"
        ref="formCopy"
        class="demo-ruleForm"
        style="max-height: 50vh; overflow-y: auto;overflow-x:hidden"
        label-width="60px"
      >
        <el-form-item label="资源" prop="ofrResourceId">
          <el-select v-model="formCopy.ofrResourceId" placeholder="请选择资源" filterable style="width: 100%">
            <el-option-group
              v-for="(group, index) in copyFormResources"
              :key="index"
              :label="group.name">
              <el-option
                v-for="item in group.resourceList"
                :key="item.ofrResourceId"
                :label="item.remarks"
                :value="item.ofrResourceId">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCopyVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCopyForm('formCopy')">确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog v-dialog-drag
      :title="`批量导入BOM`"
      :visible.sync="dialogImportVisible"
      width="30%"
      append-to-body
      top="59px"
      class="res-dialog"
    >
      <el-upload
        class="upload-demo"
        :auto-upload="false"
        drag
        action="#"
        multiple
        accept=".xlsx, .xls"
        :show-file-list="false"
        :on-change="batchImportBom">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="exportBtn">下载模板</el-link>
        </div>
      </el-upload>
    </el-dialog>

    <!-- 分享给谁 -->
    <el-dialog v-dialog-drag title="分享人" :visible.sync="dialogShareVisible"
               :append-to-body="true" width="30%" top="59px" class="res-dialog" >
      <el-form :model="form" label-width="60px">
        <el-form-item label="分享人" >
          <el-row>
            <el-col :span="16">
              <el-select v-model="form.toUserIds" placeholder="请选择分享人" style="width:97%" filterable multiple @change="changeSelect" collapse-tags>
                <el-option-group
                  v-for="group in userList"
                  :key="group.ofrResourceId">
                  <div style="padding: 0 20px">
                    <el-checkbox v-model="group.checked" @change="selectGroupAll($event,group.ofrResourceId)">{{group.resourceName}}</el-checkbox>
                  </div>
                  <el-option
                    v-for="item in group.ofrThingList"
                    :key="item.ofrThingId"
                    :label="item.name"
                    :value="item.ofrThingId + ''">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <el-table
        :data="shareList"
        style="width: 100%"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
        >
        <el-table-column
          prop="toUserName"
          label="已分享">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="分享时间"
          width="160">
          <template slot-scope="scope">
            {{parseTime(scope.row.createTime)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="70">
          <template slot-scope="scope">
            {{scope.row.status == '1' ? '已读' : '未读'}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="70">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-circle-close" @click.native.stop="handleCancel(scope.row, scope.$index)">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogShareVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitShare">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
import Resource from '@/components/resource/kind/resource.vue'
import Content from '@/components/resource/kind/content.vue'
import Alias from '@/components/resource/kind/alias.vue'
import { mapState } from 'vuex'
import DictTag from '@/components/DictTag.vue'
import Form from '@/components/Form.vue'
import OutContent from '@/components/resource/kind/content/OutIndex.vue'
import InContent from '@/components/resource/kind/content/InIndex.vue'
import qs from 'qs'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Bom from '@/components/resource/kind/bom.vue'

import InputNumberRange from '@/components/form/InputNumberRange.vue'
import History from "@/views/resource/kind/history.vue";
export default {
  computed: {
    ...mapState({
      dropDown: state => state.dropDown.dropDown,
      currentMenu: (state) => state.tags.currentMenu,
      tagsList: (state) => state.tags.tagsList
    })
  },
  components: {
    History,
    Resource,
    Content,
    DictTag,
    Form,
    OutContent,
    InContent,
    Treeselect,
    Bom,
    Alias,
    InputNumberRange
  },
  data () {
    const validateName = async (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入名称'))
      } else {
        await this.$http.get(url.getOfrResourceByName, {
          params: {
            cbRestypeId: this.cbRestypeId,
            resourceName: value,
            ofrResourceId: this.ruleForm.ofrResourceId
          }
        }).then(res => {
          this.checkCode = res.data.data
        })
        if (this.checkCode == '1') {
          callback(new Error('名称已存在，请重新输入！'))
        } else {
          callback()
        }
      }
    }
    return {
      cbRestypeId: this.$route.params.cbRestypeId,
      resData: {},
      form: {},
      dialogImportVisible: false,
      dialogShareVisible: false,
      activeName: '1',
      resourceList: [],
      shareList: [],
      resFormInline: {
        resourceName: '',
        cbowhId: null
      },
      isEditResource: false,
      isDelResource: false,
      pageNumResource: 1,
      pageSizeResource: 10,
      totalReource: 0,
      loadingResource: true,
      resourceDialog: false,
      resourceTitle: '',
      ruleFormRes: {
        resourceName: '',
        documentstatus: '',
        remarks: '',
        userId: '',
        dataSourceConfig: [],
        rprice: '',
        cprice: '',
        ggxh: '',
        jldw: '',
        rslv: '',
        sjxs: null,
        sjdw: '',
        edje: '',
        lsed: null,
        lsedBegin: null,
        lsedEnd: null,
        // edid: null,
        zqts: null,
        // zqid: null
      },
      copyRules: {
        ofrResourceId: [{ required: true, message: '请选择资源', trigger: 'change' }]
      },
      rules: {
        // resourceName: [{ required: true, validator: validateName, trigger: "blur" }],
        resourceName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        documentstatus: [{ required: true, message: '请选择状态', trigger: 'submit' }]
      },
      // ruleBelongForm: {},
      formList: [],
      isLoadingRes: false,
      checkCode: '',
      resourceIds: [],
      drawer: false,
      contentData: {},
      thingName: '',
      userList: [],
      belongDialog: false,
      cbOwhTree: [],
      name: '',
      cbussDimeList: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      cbussDimeTree: [],
      activeNames: [],
      workhistoryTitle: [],
      workhistoryList: [],
      workhistory: [],
      daterange: [],
      ofrResourceId: '',
      dimeDialog: false,
      isLoadingDime: false,
      dimeListDialog: false,
      selectDimes: [],
      resDimeList: [],
      fixedDimes: [],
      configDimes: [],
      type: '',
      dialogAddVisible: false,
      bomData: [],
      bomTitle: '',
      ofrResourceIds: [],
      dialogResVisible: false,
      resTreeList: [],
      pid: 0,
      bomId: 1,
      tempParentNode: {},
      formCopy: {},
      dialogCopyVisible: false,
      copyFormResources: [],
      // obussDimes: [{
      //   cbdId: '',
      //   dimeValue: '',
      //   dimeText: ''
      // }]
      search: '',
      resList: [],
      tableLoading: false,
      tableHeight: window.innerHeight - 244,
      pageinfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      btnMenu: JSON.parse(window.sessionStorage.getItem('btnMenu'))
      // cflowItemTree: []
    }
  },
  created () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 244
    })
    // 设置税率
    if (!this.dropDown.invoiceVat) {
      this.$http.get(url.getDataList, { params: { type: 'buss_invoice_vat' } }).then(res => {
        // console.log(res);
        // this.invoiceVat = res.data.data
        this.$store.commit('setInvoiceVat', res.data.data)
      })
    }
    // console.log(this.$route);
    // 拿资源维度列表
    this.$http.get(url.getCbussDimeList, { params: { cbussId: this.cbRestypeId, dimetype: '1' } }).then(res => {
      if (res.data.code == 200) {
        this.resDimeList = res.data.data
        const resDimeList = res.data.data.filter(item => item.isQuery == '0')
        resDimeList.forEach(item => {
          if (item.editType == '3' || item.editType == '6' || item.editType == '7' || item.editType == '20') {

            if(item.editType == '20'){
              item.children = this.getTree(JSON.parse(item.options))
            }else{
              item.children = JSON.parse(item.options).map(val => {
                return {
                  label: val.optionLabel,
                  value: val.optionValue
                }
              })
            }
            item.label = item.dimeName
            this.cbussDimeTree.push(item)
          } else if (item.editType == '12' || item.editType == '13') {
            this.$http.get(url.getResTypesAndList, {
              params: {
                cbRestypeIds: item.resourceType
              }
            }).then(res => {
              if (res.data.code == 200) {
                item.options = res.data.data.list
                this.cbussDimeList.push(item)
              }
            })
          } else if (item.editType == '14') {
            this.$http.get(url.getAllItemList, {params: {cfFlowItemId: item.cfFlowItemId}}).then(res => {
              item.options = res.data.data
              this.cbussDimeList.push(item)
            })
          } else {
            this.cbussDimeList.push(item)
          }
        })
        if (this.cbussDimeTree.length === 0) {
          this.$refs.querytree.style.width = 0
        }
        this.cbussDimeTree.forEach((item, index) => {
          this.activeNames.push(index + 1)
        })
      }
    })
    this.getData()
    this.getResList()
  },
  methods: {
    // 提交分享
    submitShare() {
      this.$http.post(url.shareCollect, qs.stringify({
        bussType: 's',
        flowType: 'r',
        obussId: this.resourceIds[0],
        toUserIds: this.form.toUserIds.toString()
      })).then(res => {
        if(res.data.code == 200) {
          this.$message.success('分享成功')
          this.dialogShareVisible = false
        }
      })
    },
    // 取消分享
    handleCancel(row, index) {
      this.$confirm('此操作将取消分享?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(url.cancelShareCollect, qs.stringify({
          bussType: 's',
          flowType: 'r',
          obussId: row.obussId,
          toUserId: row.toUserId
        })).then(res => {
          if(res.data.code == 200) {
            this.$message.success('取消分享')
            this.shareList.splice(index, 1)
          }
        })
      }).catch(() => {

      });

    },
    selectGroupAll(val, id){
      const arr = this.userList.find(f => f.ofrResourceId === id).ofrThingList.map(m => m.ofrThingId)
      if(val){
        arr.forEach(item => {
          if(!this.form.toUserIds.includes(item)){
            this.form.toUserIds.push(item + '')
          }
        })
      }else {
        this.form.toUserIds.forEach((item,index)=>{
          if(arr.includes(item)){
            this.form.toUserIds.splice(index,1,'')
          }
        })
      }
      this.form.toUserIds = this.form.toUserIds.filter(f => f != '')
    },
    changeSelect(val){
      this.userList.forEach(item => {
        const arr = item.ofrThingList.map(m => m.ofrThingId)
        item.checked = arr.every((v) => {
          return val.some(s => s == v)
        })
      })
    },
    getTree(tree) {
      let arr = [];
      if (tree.length !== 0) {
        tree.forEach(item => {
          let obj = {};
          obj.label = item.optionLabel;
          obj.value = item.optionValue;
          if (item.children && item.children.length > 0) {
            obj.children = this.getTree(item.children);
          }
          arr.push(obj);
        });
      }
      return arr
    },
    backToKind(){
      console.log(this.$route)
      const menuList = JSON.parse(window.sessionStorage.getItem('menuList'))
      console.log(menuList)
      const item = menuList.find(item => item.name === 'resource')
      const kind = this.tagsList[window.sessionStorage.getItem('currentIndex')].kind
      if(item) {

        let currentItem = item.children.find(v => v.path === '/resource/kind?kind='+kind)

        this.$router.push({path: currentItem.path})
        let obj = Object.assign({}, currentItem)
        obj.path = currentItem.path
        obj.children = currentItem.children
        obj.label = '资源'
        this.$store.commit('selectMenu', obj)
      }
      this.isActive = item.path
      this.$store.commit('setSecondMenu', item.children)
    },
    searchChange () {
      this.resList = this.currentChangePage(this.pageinfo.pageSize, 1)
    },
    // objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
    //   if (columnIndex === 0) {
    //     if (row.span) {
    //       return {
    //         rowspan: row.length,
    //         colspan: 1
    //       }
    //     } else {
    //       return {
    //         rowspan: 0,
    //         colspan: 0
    //       }
    //     }
    //   }
    //   this.tableLoading = false
    // },
    handleSizeChange1(val) {
      this.pageinfo.pageSize = val
      this.pageinfo.pageNum = 1
      this.resList = this.currentChangePage(val, this.pageinfo.pageNum)
    },
    handleCurrentChange1(val) {
      this.pageinfo.pageNum = val
      this.resList = this.currentChangePage(this.pageinfo.pageSize, val)
    },
    currentChangePage(size, current) {
      const tablePush = [];
      var array = []
      if(this.search) {
        array = this.resTreeList.filter(data => !this.search || data.remarks.toLowerCase().includes(this.search.toLowerCase()))
      }else {
        array = JSON.parse(JSON.stringify(this.resTreeList));
      }
      this.pageinfo.total = array.length
      array.forEach((item, index) => {
        if (size * (current - 1) <= index && index <= size * current - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    },
    handleResSelectionChange (selection) {
      this.ofrResourceIds = JSON.parse(JSON.stringify(selection)).map(item => item.ofrResourceId)
    },
    clickRowRes (row, column, event) {
      this.$refs.restypeTable.toggleRowSelection(row)
    },
    submitCopyForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.get(url.bomResource + this.formCopy.ofrResourceId).then(res => {
            if (res.data.code === 200) {
              this.dialogCopyVisible = false
              if (res.data.data && res.data.data.length > 0) {
                res.data.data.forEach(item => {
                  item.ofrResourceName = item.name
                  item.rid = null
                })
                this.bomData = this.$handleTree(res.data.data, 'bomId', 'pid')
              } else {
                this.bomData = []
              }
            }
          })
        } else {
          return false
        }
      })
    },
    handleCopy () {
      this.$nextTick(() => {
        // console.log(this.$refs);
        // 清除表单校验效果\
        if (this.$refs.formCopy) {
          this.$refs.formCopy.clearValidate()
        }
      })
      this.dialogCopyVisible = true
      this.formCopy = {
        ofrResourceId: '',
        rid: this.contentData.ofrResourceId
      }
      this.$http.get(url.copyBomResources).then(res => {
        // console.log(res);
        if (res.data.code === 200) {
          this.copyFormResources = res.data.data
        }
      })
    },
    // 点击维度
    handleDime () {
      this.dimeDialog = true
    },
    // 添加维度
    addDime (type) {
      this.type = type
      this.selectDimes = []
      this.dimeListDialog = true
    },
    // 增列
    addColumn (index) {
      // this.obussDimes.push({
      //   cbdId: '',
      //   dimeValue: '',
      //   dimeText: ''
      // })
      this.configDimes[index].obussDimes.push(JSON.parse(JSON.stringify(this.configDimes[index])))
      // this.configDimes.forEach(item => {
      //   item.obussDimes.push(JSON.parse(JSON.stringify(item)))
      // })
    },
    // 提交添加维度
    submitAddDime () {
      this.selectDimes.forEach(item => {
        if (this.type == 'fixed') {
          this.fixedDimes.push(JSON.parse(JSON.stringify(this.resDimeList.find(val => val.cbdId == item))))
        } else {
          const obj = JSON.parse(JSON.stringify(this.resDimeList.find(val => val.cbdId == item)))
          this.configDimes.push({
            ...obj,
            obussDimes: [obj]
          })
        }
      })

      this.dimeListDialog = false
    },
    // 删除配置维度
    handleDelete (index) {
      this.configDimes.splice(index, 1)
    },
    // 删除列
    deleteColumn (index) {
      this.obussDimes.splice(index, 1)
      this.configDimes.forEach(item => {
        item.obussDimes.splice(index, 1)
      })
    },
    // 新增bom
    handleAddBom (row) {
      this.ofrResourceIds = []

      // if(JSON.stringify(row) == '{}') {
      this.getResTypeResource()
      this.dialogResVisible = true
      this.pageinfo.pageNum = 1
      this.$nextTick(() => {
        this.$refs.restypeTable.clearSelection()
      })
      // this.pid = row.bomId
      if (row) {
        this.tempParentNode = row
      } else {
        this.tempParentNode = null
      }
    },

    getResTypeResource () {
      this.$http.get(url.resTypeResource + '?kind=' + this.resData.kind).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          res.data.data.filter(item => item.resourceList).forEach(item => {
            item.resourceList.forEach((val, index) => {
              this.resTreeList.push({
                restypeName: item.name,
                ...val,
              })
            })
          })
          this.resList = this.currentChangePage(this.pageinfo.pageSize, this.pageinfo.pageNum)
          this.pageinfo.total = this.resTreeList.length
        }
      })
    },
    // 指定列求和
    getSummaries (param) {
      // console.log(param);
      const { columns, data } = param
      const sums = []

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        // 只合计amount1和amount3，想合并哪些列就在这里指定
        if (column.property === 'quantity' || column.property === 'price') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return (prev + curr)
            } else {
              return prev
            }
          }, 0)
        }
      })
      return sums
    },
    submitRes () {
      this.dialogResVisible = false
      const bomData = []// this.getOneArr(this.bomData)

      // console.log(JSON.parse(JSON.stringify(bomData)));
      this.ofrResourceIds.forEach((item, index) => {
        // if(this.pid == 0) {
        bomData.push({
          // pid: this.pid,
          jc: '',
          ofrResourceId: item,
          quantity: '',
          price: this.getOfrResource(item, 'rprice'),
          remark: '',
          lossRate: '',
          sort: '',
          ofrResourceName: this.getOfrResource(item, 'remarks'),
          children: [],
          bomId: this.bomId++
        })
      })
      if (!this.tempParentNode) {
        this.bomData = [...this.bomData, ...bomData]
      } else {
        if (!this.tempParentNode.children) {
          this.$set(this.tempParentNode, 'children', [])
        }

        this.tempParentNode.children = [...this.tempParentNode.children, ...bomData]
      }
    },
    getOneArr (data) {
      const newData = []
      const callback = (item) => {
        (item.children || (item.children = [])).map(v => {
          callback(v)
        })
        delete item.children
        newData.push(item)
      }
      data.map(v => callback(v))
      return newData
    },
    getOfrResource (ofrResourceId, key) {
      let obj = {}
      this.resTreeList.forEach(item => {
        // if(item.resourceList){
        //   item.resourceList.forEach(val => {
        if (item.ofrResourceId == ofrResourceId) {
          obj = item
        }
        //   })
        // }
      })
      return obj[key] ? obj[key] : null
    },
    // 删除BOM
    handleDeleteBom (row) {
      // console.log(index);
      // let ofrResourceId = row.ofrResourceId
      this.bomData = this.remoteChild(this.bomData, row.bomId)
      // this.bomData.splice(index, 1)
    },
    remoteChild (list, id) {
      list = list.filter(item => {
        const flag = item.bomId != id // 过滤非匹配id
        if (flag) {
          if (item.children && item.children.length > 0) {
            item.children = this.remoteChild(item.children, id)
          }
          return true
        } else {
          return flag
        }
      })
      return list
    },
    // 提交维度
    submitDime () {
      this.isLoadingRes = true
      const data = {}
      data.dime1 = this.handleDimes(this.fixedDimes)
      data.dime2 = this.configDimes.map(item => {
        return {
          cbdId: item.cbdId,
          obussDimes: this.handleDimes(item.obussDimes)
        }
      })
      data.boms = JSON.parse(JSON.stringify(this.bomData))
      data.cbRestypeId = this.cbRestypeId
      // console.log(JSON.parse(JSON.stringify(data)));
      this.$http.post(url.addOfrResourceBomBatch, data).then(res => {
        this.isLoadingRes = false
        console.log(res)
        if (res.data.code == 200) {
          this.$message.success(res.data.msg)
          this.dimeDialog = false
          this.getResList()
        }
      })
    },
    handleDown () {
      const loading = this.$loading({
        lock: true,
        text: '下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      const cbussDimeList = this.cbussDimeTree.filter(item => item.value).map(item => {
        return {
          cbdId: item.cbdId,
          editType: item.editType,
          resourceType: item.resourceType,
          value: item.value,
          endValue: ''
        }
      })
      this.cbussDimeList.forEach(item => {
        if (item.editType == '4' || item.editType == '5' || item.editType == '9' || item.editType == '10' || item.editType == '11') {
          if (item.showValue && item.showValue.length) {
            cbussDimeList.push({
              cbdId: item.cbdId,
              editType: item.editType,
              resourceType: item.resourceType,
              value: item.showValue[0],
              endValue: item.showValue[1]
            })
          }
        } else {
          if (item.showValue) {
            cbussDimeList.push({
              cbdId: item.cbdId,
              editType: item.editType,
              resourceType: item.resourceType,
              value: item.showValue,
              endValue: ''
            })
          }
        }
      })
      this.$http({
        url: url.exportResource,
        method: 'post',
        data: {
          cbRestypeId: this.cbRestypeId,
          pageNum: 1,
          pageSize: 2000,
          ...this.resFormInline,
          cbussDimeList
        },
        responseType: 'blob',
        headers: { // 注意
          'Content-Type': 'application/json; application/octet-stream'
        }
      }).then(res => {
        console.log(res)
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/x-excel' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.download = this.resData.restypeName + '.xlsx'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        // let name = this.resData.restypeName + '.zip'
        // this.fileHandleCompressed(res, name);
        loading.close()
      }).catch(err => {

      })
      // 获取资源列表
      // this.$http.post(url.exportResource,  {
      //   cbRestypeId: this.cbRestypeId,
      //   pageNum: 1,
      //   pageSize: 2000,
      //   resourceName: this.resFormInline.resourceName,
      //   cbowhId: this.resFormInline.cbowhId,
      //   cbussDimeList
      //   // : cbussDimeList.length ? JSON.stringify(cbussDimeList) : ''
      // }).then(res => {
      //   if(res.data.code == 200) {
      //     // this.resourceList = res.data.data.list
      //     // this.totalReource = res.data.data.total
      //     // this.loadingResource = false
      //   }
      // })
    },
    // 文件流转为zip
    fileHandleCompressed (data, fileName) {
      // let blob = new Blob([data], { type: 'application/zip,charset=utf-8'})//此处必须添加
      const blob = data
      const url = window.URL.createObjectURL(blob)
      const link = window.document.createElement('a') // 创建a标签
      link.href = url
      link.download = fileName // 重命名文件
      link.click()
      URL.revokeObjectURL(url) // 释放内存
    },
    handleChange (val) {
      // console.log(val);
    },
    changeSwitch (e, row) {
      // console.log(e);
      // console.log(row);

      this.$http.post(url.editResourceShow + row.ofrResourceId + '/' + e).then(res => {
        if (res.data.code === 200) {
          this.$message.success(res.data.msg)
        }
      })
    },
    changeSwitch2 (e, row) {
      // console.log(e);
      // console.log(row);

      this.$http.post(url.editResourceOjdt + row.ofrResourceId + '/' + e).then(res => {
        if (res.data.code === 200) {
          this.$message.success(res.data.msg)
        }
      })
    },
    handleNodeClick (e, index) {
      this.cbussDimeTree[index].value = this.cbussDimeTree[index].value == e.value ? '' : e.value
      this.cbussDimeList.forEach(item => {
        if(this.cbussDimeTree[index].cbdId == item.cbdId && this.cbussDimeTree[index].cbsId == item.cbsId) {
          item.showValue = this.cbussDimeTree[index].value
        }
      })
      if(!this.cbussDimeTree[index].value) {
        this.$nextTick(() => {
          this.$refs['tree' + (index + 1)][0].setCurrentKey(null)
        })
      }
      this.pageNum = 1
      this.getResList()
    },
    judgeButton (type) {
      return this.btnMenu.some(item => item.perms === `${this.currentMenu.kind}:${type}`)
    },
    judgeHistoryButton (type) {
      return this.resData.cfflowworkIds && this.btnMenu.some(item => item.perms === `${this.currentMenu.kind}:${type}`)
    },
    /** 转换数据结构 */
    // normalizer1(node) {
    //   // this.$nextTick(() => {
    //     if (node.children == null || node.children.length == 0) {
    //       delete node.children;
    //     }
    //     // console.log(node.typeLevel);
    //     // return {
    //     //   id: node.cbOwhId,
    //     //   label: node.name,
    //     //   children: node.children
    //     // };
    //   // })
    // },
    // 请求数据kindDealType
    async getData () {
      await this.$http.get(url.getResType, { params: { cbRestypeId: this.cbRestypeId } }).then(res => {
        this.resData = res.data.data
        // 获取归属人列表
        this.$http.get(url.getPostAndUserList).then(res => {
          if (res.data.code == 200) {
            this.userList = res.data.data
          }
        })
      })

      // // 伙伴--额度、账期
      // if(this.resData.kind == '7' && (this.resData.edgl == '0' || this.resData.zqgl == '0')) {
      //   this.$http.get(url.getCflowItemTree).then(res => {
      //     if(res.data.code == 200) {
      //       this.cflowItemTree = res.data.data
      //       this.cflowItemTree.forEach(process => {
      //         process.isDisabled = true
      //         if(process.children) {
      //           process.children.forEach(deal => {
      //             deal.isDisabled = true
      //           })
      //         }
      //       })
      //     }
      //   })
      // }
      // 获取位置树
      this.$http.get(url.getCbOwhByCbResType, {
        params: {
          cbRestypeIds: this.cbRestypeId
        }
      }).then(res => {
        if (res.data.code == 200) {
          const arr = res.data.data
          if (arr.length) {
            arr.push({
              cbOwhId: -1,
              name: '其它',
              pid: 0,
              children: []
            })
          }
          this.cbOwhTree = this.$handleTree(arr, 'cbOwhId', 'pid')
        }
      })
    },
    /** 转换数据结构 */
    normalizer (node) {
      // this.$nextTick(() => {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.cbOwhId,
        label: node.name,
        children: node.children
      }
      // })
    },
    getResList () {
      this.loadingResource = true
      // // 获取资源列表
      // this.$http.get(url.getOfrResourceList, {params: {
      //   cbRestypeId: this.cbRestypeId,
      //   pageNum: this.pageNumResource,
      //   pageSize: this.pageSizeResource,
      //   resourceName: this.resFormInline.resourceName
      // }}).then(res => {
      //   if(res.data.code == 200) {
      //     this.resourceList = res.data.data.list
      //     this.totalReource = res.data.data.total
      //     this.loadingResource = false
      //   }
      // })
      const cbussDimeList = this.cbussDimeTree.filter(item => item.value).map(item => {
        return {
          cbdId: item.cbdId,
          editType: item.editType,
          resourceType: item.resourceType,
          value: item.value,
          endValue: ''
        }
      })
      this.cbussDimeList.forEach(item => {
        if (item.editType == '4' || item.editType == '5' || item.editType == '9' || item.editType == '10' || item.editType == '11') {
          if (item.showValue && item.showValue.length) {
            cbussDimeList.push({
              cbdId: item.cbdId,
              editType: item.editType,
              resourceType: item.resourceType,
              value: item.showValue[0],
              endValue: item.showValue[1]
            })
          }
        } else {
          if (item.showValue) {
            cbussDimeList.push({
              cbdId: item.cbdId,
              editType: item.editType,
              resourceType: item.resourceType,
              value: item.showValue,
              endValue: ''
            })
          }
        }
      })
      // 获取资源列表
      this.$http.post(url.OfrResourceList, {
        cbRestypeId: this.cbRestypeId,
        pageNum: this.pageNumResource,
        pageSize: this.pageSizeResource,
        ...this.resFormInline,
        cbussDimeList
        // : cbussDimeList.length ? JSON.stringify(cbussDimeList) : ''
      }).then(res => {
        if (res.data.code == 200) {
          this.resourceList = res.data.data.list
          this.totalReource = res.data.data.total
          this.loadingResource = false
        }
      })
    },
    inquire () {
      this.pageNumResource = 1
      this.getResList()
    },
    reset () {
      for (const key in this.resFormInline) {
        this.resFormInline[key] = ''
      }
      this.resFormInline.cbowhId = null
      this.pageNumResource = 1
      this.cbussDimeTree.forEach((item, index) => {
        item.value = ''
        this.$refs['tree' + (index + 1)][0].setCurrentKey(null)
      })
      this.cbussDimeList.forEach(item => {
        item.showValue = null
      })
      this.getResList()
    },
    // 新增资源
    addResource () {
      this.resourceTitle = '新增' + this.resData.restypeName
      this.resourceDialog = true
      this.$nextTick(() => {
        // 清除表单校验效果
        this.$refs.ruleFormRes.clearValidate()
      })
      // 初始化表单内容
      for (const key in this.ruleFormRes) {
        if (key == 'documentstatus') {
          this.ruleFormRes[key] = '1'
        } else if (key == 'userId') {
          // console.log(JSON.stringify(sessionStorage.getItem('loginUser')));
          this.ruleFormRes[key] = JSON.parse(sessionStorage.getItem('loginUser')).bussId
        } else {
          this.ruleFormRes[key] = null
        }
      }
      this.$http.get(url.getCbussDimeList, { params: { cbussId: this.cbRestypeId, dimetype: '1' } }).then(res => {
        if (res.data.code == 200) {
          this.formList = this.handleFormList(res.data.data)
          this.formList.forEach(item => {
            if(item.dvalue){
              item.dimeValue = item.dvalue
              item.dimeText = item.dvalue
            }
          })
          this.ruleFormRes.dataSourceConfig = this.formList
        }
      })
    },
    // 修改资源
    editResource (row) {
      if (this.$refs.ruleFormRes) {
        this.$nextTick(() => {
          // 清除表单校验效果
          this.$refs.ruleFormRes.clearValidate()
        })
      }
      this.resourceTitle = '编辑' + this.resData.restypeName
      this.resourceDialog = true
      const id = row.ofrResourceId || this.resourceIds[0]
      this.$http.get(url.getOfrResource, { params: { ofrResourceId: id } }).then(res => {
        // console.log(res.data.data);
        const data = res.data.data.ofrResource
        for (const key in data) {
          this.ruleFormRes[key] = data[key]
        }
        this.formList = this.handleFormList(res.data.data.dimensionList)
        this.ruleFormRes.dataSourceConfig = this.formList
      })
    },
    // 修改资源
    copyResource (row) {
      if (this.$refs.ruleFormRes) {
        this.$nextTick(() => {
          // 清除表单校验效果
          this.$refs.ruleFormRes.clearValidate()
        })
      }
      this.resourceTitle = '编辑' + this.resData.restypeName
      this.resourceDialog = true
      const id = row.ofrResourceId || this.resourceIds[0]
      this.$http.get(url.getOfrResource, { params: { ofrResourceId: id } }).then(res => {
        // console.log(res.data.data);
        const data = res.data.data.ofrResource
        for (const key in data) {
          this.ruleFormRes[key] = data[key]
        }
        this.formList = this.handleFormList(res.data.data.dimensionList)
        this.ruleFormRes.dataSourceConfig = this.formList
        this.ruleFormRes.ofrResourceId = null
        this.ruleFormRes.remarks = null
        this.ruleFormRes.documentstatus = '1'
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoadingRes = true
          // console.log();
          const dimes = this.handleDimes(this.formList)
          // this.formList.forEach(item => {
          //   let obj = {}
          //   obj.cbdId = item.cbdId
          //   obj.dimeValue = item.dimeValue
          //   dimes.push(obj)
          // })
          // console.log(dimes);
          delete this.ruleFormRes.dataSourceConfig
          const obj = {
            ...this.ruleFormRes,
            cbRestypeId: this.cbRestypeId,
            documentstatus: '1',
            dimes: JSON.stringify(dimes)
          }
          if (!this.ruleFormRes.ofrResourceId) {
            // console.log(JSON.stringify(dimes));
            this.$http.post(url.addOfrResource, qs.stringify(obj)).then(res => {
              this.isLoadingRes = false
              if (res.data.code === 200) {
                this.$message.success(res.data.msg)
                this.resourceDialog = false
                this.pageNumResource = 1
                this.getResList()
              }
            })
          } else {
            this.$http.post(url.editOfrResource, qs.stringify({
              ...this.ruleFormRes,
              documentstatus: this.ruleFormRes.documentstatus ? this.ruleFormRes.documentstatus : '1',
              dimes: JSON.stringify(dimes)
            })).then(res => {
              this.isLoadingRes = false
              if (res.data.code === 200) {
                this.$message.success(res.data.msg)
                this.resourceDialog = false
                this.pageNumResource = 1
                this.getResList()
              }
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除资源
    deleteResource (row) {
      const resourceIds = row.ofrResourceId || this.resourceIds.toString()
      this.$confirm('此操作将永久删除该资源, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(url.removeOfrResource, qs.stringify({ ofrResourceIds: resourceIds })).then(res => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getResList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleBatch () {
      this.ruleFormRes.userId = JSON.parse(sessionStorage.getItem('loginUser')).bussId
      this.belongDialog = true
    },
    handleShare(){
      this.dialogShareVisible = true
      this.$http.get(url.getShareToList, {params: {flowType: 'r', obussId: this.resourceIds[0]}}).then(res => {
        if(res.data.code == 200) {
          this.loading = false
          this.shareList = res.data.data
        }
      })
    },
    submitBelong () {
      const obj = {
        ofrResourceIds: this.resourceIds.toString(),
        userId: this.ruleFormRes.userId
      }
      this.isLoadingRes = true
      this.$http.post(url.editOfrResourceBelong, qs.stringify(obj)).then(res => {
        this.isLoadingRes = false
        if (res.data.code === 200) {
          this.$message.success(res.data.msg)
          this.belongDialog = false
          this.getResList()
        }
      })
    },
    // 查看内容
    async handleContent (row) {
      await this.$http.get(url.getOfrResource, { params: { ofrResourceId: row.ofrResourceId } }).then(res => {
        if (res.data.code == 200) {
          this.contentData = res.data.data.ofrResource
          this.contentData.kind = this.resData.kind
        }
      })
      this.drawer = true
      // this.$http.get(url.infoThingalias + this.resData.cbRestypeId + '/' + 0).then(res => {
      //   if(res.data.code == 200 && res.data.data) {
      //     this.name = res.data.data[this.thing] ? res.data.data[this.thing] : '名称'
      //   }else {
      //     this.name = '名称'
      //   }
      // })
      const kind = this.resData.kind
      if ((kind == '2' || kind == '3' || kind == '6' || kind == '7') && this.judgeButton('his')) {
        this.ofrResourceId = row.ofrResourceId
      }

      if (this.resData.kindDealType == '1') {
        this.thingName = this.resData.isBom == '0' ? '8' : '2'
      } else {
        this.thingName = this.resData.isBom == '0' ? '7' : '1'
        // console.log(this.$refs.inContent);
        if (this.$refs.inContent) {
          this.$refs.inContent.getList()
        }
      }
    },
    handleSelectionChange (rows) {
      this.resourceIds = rows.map(item => item.ofrResourceId)
      this.isEditResource = rows.length === 1
      this.isDelResource = rows.length
    },
    handleSizeChange (val) {
      this.pageSizeResource = val
      this.pageNumResource = 1
      this.getResList()
    },
    handleCurrentChange (val) {
      this.pageNumResource = val
      this.getResList()
    },
    exportBtn () {
      const loading = this.$loading({
        lock: true,
        text: '下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      this.$http({
        url: url.batchImportBomTemplate,
        method: 'post',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json; application/octet-stream'
        }
      }).then(res => {
        // console.log(res);
        const url = window.URL.createObjectURL(new Blob([res]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', `BOM批量导入模板${new Date().getTime()}.xls`)
        document.body.appendChild(link)
        link.click()
        loading.close()
      })
    },
    // bom导入
    handleBatchImport () {
      this.dialogImportVisible = true
    },
    batchImportBom (file) {
      const loading = this.$loading({
        lock: true,
        text: '导入中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      // this.progressFlag = true
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('rid', this.contentData.ofrResourceId)
      // let time = new Date().getTime() + Math.random()
      // formData.append('key', time)
      // this.getProgress(time)
      this.$http.post(url.batchImportBomData,
        formData
      ).then(res => {
        loading.close()
        if (res.data.code == 200) {
          this.$message.success(res.data.msg)
          this.dialogImportVisible = false
        }
      })
    }
  },
  inject: ['reload'], // 注入   和methods同级
  watch: {
    $route (to, from) {
      this.reload()
    }
  }
}
</script>

<style lang="scss" scoped>

 .res-dialog {
  ::v-deep .el-dialog {
    margin: 0 auto;
    max-height: calc(100% - 72px);
    height: auto;
  }
  ::v-deep .el-dialog__body {
    padding: 10px 20px 10px 20px;
    max-height: calc(100vh - 206px);
    height: auto;
    overflow: auto;
  }
 }
.right-input {
  ::v-deep .el-input__inner {
    text-align: right;
  }
}
.detail {

  /* padding: 16px; */
  .des, .list {
    background: #FFFFFF;
    box-shadow: 2px 3px 8px 0px rgba(208,208,208,0.5);
    border-radius: 11px;
    padding: 16px;
    /* text-align: center; */
    padding-bottom: 0;
    margin-bottom: 16px;
    box-sizing: border-box;
  }
  .des {
    ::v-deep .el-descriptions-item__label:not(.is-bordered-label) {
      /* width: 52px; */
      text-align: right;
      text-align-last: justify;
      display: block;
      margin-right: 0;
    }
    .colon {
      margin-right: 8px;
    }
  }
  .list{
    margin-bottom: 0;
    overflow: hidden;
    .contain {
      display: flex;
      .left {
        width: 180px;
        overflow: auto;
        /* flex-shrink: 0; */
        /* max-height: calc(100vh - 100px); */
        /* background: pink; */
        margin-right: 10px;
        ::v-deep .el-collapse-item__content {
          padding-bottom: 8px;
        }
        ::v-deep .el-collapse-item__header {
          height: 30px;
          line-height: 30px;
        }
      }
      .right {
        flex: 1;
        overflow: auto;
        /* flex-shrink: 1; */
        /*  */
      }
    }
    .el-table {
      margin-bottom: 16px;
    }
    .tabs1 {
      margin-bottom: 16px;
      ::v-deep >.el-tabs__header {
        border: 0;
        padding-bottom: 30px;
        margin: 0;
        border-bottom: 1px solid #E8E8E8;
        margin-bottom: 16px;
      }
      ::v-deep .el-tabs__item {
        border: 0;
        padding: 6px 16px 6px 32px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282828;
        line-height: 20px;
        box-sizing: content-box;
        background-color: #F2F2F2;
        position: relative;
        margin-right: 16px;
      }
      ::v-deep .el-tabs__item::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        border: 16px solid rgba($color: #000000, $alpha: 0);
        border-left: 16px solid #fff;
      }
      ::v-deep .el-tabs__item::after {
        content: '';
        position: absolute;
        top: 0;
        right: -32px;
        border: 16px solid rgba($color: #000000, $alpha: 0);
        border-left: 16px solid #F2F2F2;
      }
      ::v-deep .el-tabs__nav {
        border: 0;
      }
      ::v-deep .el-tabs__item.is-active {
        color: #fff;
        background-color: #0C75E5;
      }
      ::v-deep .el-tabs__item.is-active::after {
        border-left: 16px solid #0C75E5;
      }
    }
  }
  .title {
    height: 14px;
    font-size: 14px;
    font-family: STHeitiSC-Medium, STHeitiSC;
    font-weight: 500;
    color: #282828;
    line-height: 15px;
    padding-left: 8px;
    border-left: #0C75E5 2px solid;
    margin-bottom: 16px;
    font-weight: bolder;
  }
}
::v-deep .el-dialog__body {
  padding: 30px 0 30px 20px;
}
</style>
